import React from "react";
import { DatoTotal, PanelTotales } from "./PanelTotales";

// Totales de todas las tancadas de la orden, sin separar por tipo de carga. Los
// kg secos dejan fuera las cargas que todavía no tienen DRC
export const TancadasTotales = ({ totales = {} }) => (
    <PanelTotales alineacion="end">
        <DatoTotal etiqueta="Total húmedos:" kg={totales.total_kg_humedos} />
        <DatoTotal etiqueta="Total secos:" kg={totales.total_kg_secos} />
    </PanelTotales>
);
